"use strict"

const api = process.env.API_URL
const app = process.env.APP_URL

export class Mody {

    async init() {
        const qs = document.querySelector('script[data-mody]')

        // Script tag not found
        if (!qs) {
            console.error("No <script data-mody> tag found");
            return;
        }

        // Get browser lang or page lang
        this.lang = (document.documentElement.getAttribute("lang") || qs.getAttribute("data-lang") || window.navigator.language).split('-')[0]
        this.langCode = (document.documentElement.getAttribute("lang") || qs.getAttribute("data-lang") || window.navigator.language)

        // Get tag attribute
        this.tags = this.getElmsTag()
        if(this.tags.length === 0) {
            console.error("No tags found")
            return
        }

        // Get entity attribute
        const parts = window.location.hostname.split('.')
        this.slug = qs.getAttribute("data-entity") || parts[parts.length - 2]

        // Get entity resource
        this.entity = (await this.getEntity()).data || null
        if (!this.entity) {
            console.error("Invalid entity")
            return
        }

        // Lang fallback
        if (!this.entity.i18n.hasOwnProperty(this.lang)) {
            this.lang = 'en';
        }

        // Get item attribute
        await this.getItemTag()
        if (!this.item) {
            console.error("No item found")
            return
        }

        // Service
        this.service = qs.getAttribute("data-service") || this.entity.app || "mx"

        // Get local storage user value
        this.user = localStorage.getItem("m_user")

        this.css = null
        this.meas = null
        this.size = null
        this.stopGetMeas = false

        // Create Mody btn
        await this.create()

        // Observer
        let that = this
        let item = this.item
        let config = { childList: true, subtree: true };

        let callback = async function (mutationsList, observer) {
            let elm = document.querySelector('script[data-mody]');
            if (elm) {
                let previousTags = that.tags
                let currentTags = that.getElmsTag()
                // Compare
                if (!that.areTagsConsistent(previousTags, currentTags) && currentTags.length > 0) {
                    // Get item attribute
                    await that.getItemTag();
                    if (that.item && currentTags) {
                        item = that.item;
                        // Set current tag attribute
                        that.tags = currentTags
                        // Create Mody btn
                        await that.create();
                        // Refresh tag
                        that.tags = that.getElmsTag();
                    }
                }
            }
        };
        // Create an observer instance linked to the callback function
        let observer = new MutationObserver(callback);
        // Start observing the target node for configured mutations
        observer.observe(document.body, config);

    }

    async create() {
        let that = this;
        let item = await that.getItem();

        // Item not found
        if (!item.data) {
            console.error(`Not found: ${that.item}`);
            return;
        }

        if (!this.isListenerAdded) {
            // Remove existing event listener if present
            if (this.messageEventListener) {
                window.removeEventListener('message', this.messageEventListener);
            }

            // Define the event listener function and assign to class property
            this.messageEventListener = function(event) {
                // Check if event source is mody, otherwise ignore
                if (event.data && typeof event.data !== 'object' && event.origin.includes(app)) {
                    let msg = JSON.parse(event.data);

                    // Check type
                    const actionMap = {
                        ctaMxfStart: { key: 'ctaMxfStart', needsSize: false },
                        ctaMxfEnd:   { key: 'ctaMxfEnd',   needsSize: true  },
                        ctaMxsStart: { key: 'ctaMxsStart', needsSize: false },
                        ctaMxsEnd:   { key: 'ctaMxsEnd',   needsSize: true  }
                    };

                    const action = actionMap[msg.type];

                    if (
                        action &&
                        that.entity.actions &&
                        typeof that.entity.actions[action.key] === 'string' &&
                        (!action.needsSize || msg.size != null)
                    ) {
                        let func = new Function(that.entity.actions[action.key]);
                        action.needsSize
                            ? func.call(null, msg.size)
                            : func.call(null);
                    }

                    // User size
                    if (msg.size) {
                        document.querySelectorAll(".mody_btn").forEach(function (elm) {
                            elm.innerHTML = '<div class="mody_btn_icon">' + 
                                '<img src="' + (that.entity.config.style.image != null
                                    ? that.entity.config.style.image
                                    : 'https://storage.googleapis.com/mody-p_assets/mody/mody.svg'
                                ) + '" alt="mody icon" width="100%" style="' + 
                                (that.entity.config.style.icon != null 
                                    ? that.entity.config.style.icon 
                                    : 'width:30px; padding:2px;'
                                ) + '">' +
                            '</div>' +
                            '<button class="mody_btn_cta" style="' + that.entity.config.style.cta + '" type="button">' + that.entity.i18n[that.lang].success.replace("$mody-size", '&nbsp;' + msg.size) + '</button>';
                        });

                        // Set local item
                        localStorage.setItem("m_user", msg.user);
                        localStorage.setItem("m_gender", msg.gender);

                        // Success action
                        /*if (that.entity.actions && that.entity.actions.success) {
                            let func = new Function(that.entity.actions.success);
                            func.call(null, msg.size);
                        }*/
                    }

                    // Close app
                    if (msg.close) {
                        // Add to cart action
                        if (that.entity.actions && that.entity.actions.cart && msg.cart) {
                            let func = new Function(that.entity.actions.cart);
                            func.call(null);
                        }
                        document.querySelector('.mody_dialog-container')?.remove();
                        document.body.style.overflow = '';
                        that.stopGetMeas = true;
                    }
                }
            }

            window.addEventListener('message', this.messageEventListener);

            // Listener added
            this.isListenerAdded = true;
        }

        if (that.tags.length > 0) {
            // Loop tags
            that.tags.forEach(function (ref) {
                let mody = document.createElement('div');
                mody.className = 'mody_btn';
                mody.style = that.entity.config.style.btn;
                mody.innerHTML ='<div class="mody_btn_icon">' + 
                        '<img src="' + (that.entity.config.style.image != null
                            ? that.entity.config.style.image
                            : 'https://storage.googleapis.com/mody-p_assets/mody/mody.svg'
                        ) + '" alt="mody icon" width="100%" style="' + 
                        (that.entity.config.style.icon != null 
                            ? that.entity.config.style.icon 
                            : 'width:30px; padding:2px;'
                        ) + '">' +
                    '</div>' +
                    '<button class="mody_btn_cta" style="' + that.entity.config.style.cta + '" type="button">' + that.entity.i18n[that.lang].cta + '</button>' +
                    '<a id="mody_anchor" target="_blank"></a>';
                // Set click event on action btn
                mody.onclick = async function () {
                    // Prevent multiple click
                    that.stopGetMeas = false;
                    // Start meas and check platform
                    that.startMeas(item).then(function () {
                        that.displayEmbed();
                    });
                    // Click action
                    if (that.entity.actions && that.entity.actions.ctaMxsStart) {
                        let func = new Function(that.entity.actions.ctaMxsStart);
                        func.call(null);
                    }
                };
                // Clear all existing children
                while (ref.firstChild) {
                    ref.removeChild(ref.firstChild);
                }
                // Append action btn
                ref.appendChild(mody);
            });

            // Fast check meas if user exists
            if (this.user) {
                await that.checkMeas(item);
            }
        }
    }

    /* Meas */

    async startMeas (item) {
        if (!this.user || this.user && item.data.gender !== localStorage.getItem("m_gender")) {
            this.user = await this.postUser()
        }
        // Create meas
        let meas = await this.postMeas()
        this.meas = meas.uuid
        this.gender = meas.gender
    }

    async checkMeas (item) {
        try {
            if (item.data.gender === localStorage.getItem("m_gender")) {
                const meas = await this.postMeas()
                this.meas = meas.uuid
                await this.getMeas()
                // Cta suggestion
                if (this.entity.actions && this.entity.actions.ctaSuggestion) {
                    let func = new Function(this.entity.actions.ctaSuggestion);
                    func.call(null);
                }
            }
        } catch (error) {
            localStorage.removeItem("m_gender")
            // Handle postMeas fails error
            console.log(`Failed to create meas: ${error}`)
        }
    }

    /* Utils */

    mobile() {
        return !!(navigator.userAgent.toLowerCase().match(/mobile/i) || navigator.userAgent.toLowerCase().match(/ipad/i) || (/Macintosh/.test(navigator.userAgent) && 'ontouchend' in document))
    }

    async getItemTag() {
        this.item = document.querySelector('script[data-mody]').getAttribute("data-item") || (() => {
            const regexArray = this.entity.config.regexArray || null; // Check if regexArray is set
            const url = window.location.href.replace(/(.html).*$/, '$1'); // Clean the URL
            if (regexArray && Array.isArray(regexArray) && regexArray.length > 0) {
                // Use the array of regex patterns
                const results = regexArray.map(pattern => {
                    const regex = new RegExp(pattern);
                    const match = url.match(regex);
                    return match ? match.pop() : null;
                });
                return results.filter(Boolean).join('');
            } else {
                // TODO deprecated
                const regex = new RegExp(this.entity.config.regex); // Old single regex logic
                const match = url.match(regex);
                return match ? match.pop() : null;
            }
        })();
    }

    getElmsTag() {
        let elm;
        let tag = document.querySelector('script[data-mody]').getAttribute("data-tag");
        // ID elm
        if (!tag.startsWith('#')) {
            elm = '#' + tag;
        }
        let foundTags = document.querySelectorAll(elm || tag);
        // If the element is not found by ID, try finding by class
        if (!foundTags || foundTags.length === 0) {
            if (!tag.startsWith('.')) {
                elm = '.' + tag;
            }
            foundTags = document.querySelectorAll(elm || tag);
        }
        return foundTags;
    }

    areTagsConsistent(previousTags, currentTags) {
        // Return false if either input is falsy or lengths do not match
        if (!previousTags || !currentTags || previousTags.length !== currentTags.length) {
            return false;
        }

        // Function to compare only child nodes
        function areChildNodesConsistent(prevElement, currElement) {
            // One or both elements are missing
            if (!prevElement || !currElement) {
                return false;
            }

            // Number of child nodes do not match
            if ( prevElement.childNodes.length !== currElement.childNodes.length) {
                return false;
            }

            // Compare child nodes recursively
            for (let i = 0; i < prevElement.childNodes.length; i++) {
                const prevChild = prevElement.childNodes[i];
                const currChild = currElement.childNodes[i];

                // Compare node types and values
                if (
                    prevChild.nodeType !== currChild.nodeType ||
                    (prevChild.nodeValue && prevChild.nodeValue !== currChild.nodeValue)
                ) {
                    return false;
                }

                // If both are elements, recursively compare their child nodes
                if (
                    prevChild.nodeType === Node.ELEMENT_NODE &&
                    !areChildNodesConsistent(prevChild, currChild)
                ) {
                    return false;
                }
            }

            return true;
        }

        // Compare elements and collect differences
        return Array.from(previousTags).every((prevTag, index) => {
            const currentTag = currentTags[index];
            return areChildNodesConsistent(prevTag, currentTag);
        });
    }

    /* Display actions */
    displayEmbed() {
        let dialogContainer = document.querySelector('.mody_dialog-container')

        if (!dialogContainer) {
            dialogContainer = document.createElement('div')
            dialogContainer.classList.add('mody_dialog-container')
            document.body.style.overflow = 'hidden';

            const iframe = document.createElement('iframe')
            iframe.src = `${app}/${this.service}/${this.slug}/${this.meas}/${this.user}?lang=${this.langCode}`
            iframe.allow = "camera; fullscreen; accelerometer; gyroscope; magnetometer";
            dialogContainer.appendChild(iframe)
            document.body.appendChild(dialogContainer)
        }
    }

    async getMeas() {
        try {
            const response = await fetch(`${api}/api/e/${this.slug}/meas/${this.meas}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-User": this.user
                }
            });
            const data = await response.json();
            if (data.status === 'success' || data.data.size != null) {
                let that = this;
                // set meas found
                if (that.entity.actions && that.entity.actions.suggested) {
                    let func = new Function(that.entity.actions.suggested);
                    func.call(null, data.data.size);
                }
                document.querySelectorAll(".mody_btn").forEach(function (elm) {
                    elm.innerHTML = '<div class="mody_btn_icon">' + 
                            '<img src="' + (that.entity.config.style.image != null
                                ? that.entity.config.style.image
                                : 'https://storage.googleapis.com/mody-p_assets/mody/mody.svg'
                            ) + '" alt="mody icon" width="100%" style="' + 
                            (that.entity.config.style.icon != null 
                                ? that.entity.config.style.icon 
                                : 'width:30px; padding:2px;'
                            ) + '">' +
                        '</div>' +
                        '<button class="mody_btn_cta" style="' + that.entity.config.style.cta + '" type="button">' + that.entity.i18n[that.lang].success.replace("$mody-size", '&nbsp;' + data.data.size) + '</button>';
                });
                return data.data;
            }
        } catch (error) {
            console.error("Failed to fetch meas:", error);
            return null;
        }
    }

    async postUser() {
        try {
            const response = await fetch(`${api}/api/u`, {
                method: "POST",
            });
            const data = await response.json();
            return data.data;
        } catch (error) {
            console.error("Failed to post user:", error);
            return null;
        }
    }

    async postMeas() {
        try {
            const response = await fetch(`${api}/api/e/${this.slug}/meas`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-User": this.user
                },
                body: JSON.stringify({
                    item: this.item,
                    service: this.service,
                    country: this.langCode.includes("-") ? this.langCode.split("-")[1].toLowerCase() : this.langCode.toLowerCase(),
                    source: this.mobile() ? 'mobile' : 'desktop'
                })
            });
            const data = await response.json();
            return data.data;
        } catch (error) {
            console.error("Failed to post meas:", error);
            return null;
        }
    }

    async getItem() {
        try {
            const response = await fetch(`${api}/api/e/${this.slug}/items/${this.item}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-User": this.user
                }
            });
            return await response.json();
        } catch (error) {
            console.error("Failed to fetch item:", error);
            return null;
        }
    }

    async getEntity() {
        try {
            const response = await fetch(`${api}/api/e/${this.slug}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            });
            return await response.json();
        } catch (error) {
            console.error("Failed to fetch entity:", error);
            return null;
        }
    }
}
